import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import About from './components/About';
import MapView from './components/MapView';
import { ThemeProvider } from '@material-ui/core/styles'
import { theme } from './theme'
import './custom.css'

//export default () => (
//    <Layout>
//        <Route exact path='/' component={MapView} />
//        <Route path='/about' component={About} />
//    </Layout>
//);


const App = () => (
    <ThemeProvider theme={theme}>
        <Layout>
            <Route exact path='/' component={MapView} />
            <Route path='/about' component={About} />
        </Layout>
    </ThemeProvider>
)

export default App;